<template>
  <div
    class="collect-card"
    :class="{
      'athena-overlap': card_animate == 'overlap',
    }"
  >
    <a class="athena-card" :href="list.term.slug ? `/collections/${list.term.slug}` : null">
      <div
        class="collections-image"
        :class="{
          overlap: card_animate == 'overlap',
        }"
      >
        <v-lazy-img
          class="img-fluid"
          :alt="list.term.name"
          :data-url="feature_image && feature_image.url"
          :src="feature_image && feature_image.thumbnail"
        ></v-lazy-img>
      </div>
      <p :style="{ fontSize: getCol() }" class="secondary_title text-center">{{ list.name }}</p>
    </a>
  </div>
</template>

<script>
export default {
  props: ['list', 'card_animate', 'layout'],
  methods: {
    getCol() {
      let size = '28px'
      switch (this.layout) {
        case '3columns':
          size = '28px'
          break
        case '4columns':
          size = '24px'
          break
        case '5columns':
          size = '20px'
          break
        default:
          size = '28px'
          break
      }
      return size
    },
  },
  computed: {
    feature_image() {
      let { thumbnail, first_product_image } = this.list
      if (thumbnail && Object.keys(thumbnail).length) {
        return thumbnail
      }
      if (first_product_image && Object.keys(first_product_image).length) {
        return first_product_image
      }
    },
  },
}
</script>
 
<style lang="scss" scoped>
.collect-card {
  margin-bottom: 20px;
}
.athena-overlap {
  margin-bottom: 20px;
  p {
    margin-top: 30px;
  }
  .collections-image {
    position: relative;
    width: 100%;
    padding-top: 100%;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
    }
  }
}

.athena-card {
  .collections-image {
    position: relative;
    overflow: hidden;
    img {
      transition: 0.6s all;
    }
  }
  .collections-image:before {
    content: '';
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in;
    z-index: 1;
  }
  .collections-image:hover img {
    transform: translate3d(0, 0, 0) scale(1.0375);
    opacity: 0.8;
  }
  .collections-image:hover::before {
    visibility: visible;
    opacity: 1;
  }
  p {
    font-size: 28px;
    font-weight: 500;
    color: #262626;
    line-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media screen and (max-width: 767px) {
  .athena-card {
    p {
      font-size: 14px !important;
      line-height: 21px !important;
    }
  }
}
</style>